<div class="groups-dialog-container">
  <!-- En-tête -->
  <div class="dialog-header">
    <div class="header-content">
      <div class="user-info">
        <div class="user-avatar">
          {{ getInitials() }}
        </div>
        <div class="user-details">
          <h2 class="dialog-title">Gestion des Groupes</h2>
          <p class="user-name">{{ user.firstName }} {{ user.lastName }}</p>
          <p class="user-email">{{ user.email }}</p>
        </div>
      </div>
      <button mat-icon-button class="close-btn" (click)="close()" [disabled]="loading">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Message d'erreur -->
  @if (errorMessage) {
    <div class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ errorMessage }}</span>
      <button mat-icon-button (click)="errorMessage = ''" [disabled]="loading">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <!-- Champ de recherche -->
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Rechercher un groupe</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        placeholder="Nom ou chemin du groupe..."
        autocomplete="off"
        [disabled]="loading"
        >
        <mat-icon matPrefix>search</mat-icon>
        @if (searchControl.value && !loading) {
          <button
            mat-icon-button
            matSuffix
            (click)="clearSearch()"
            >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>

    <!-- Loader -->
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Chargement des groupes...</p>
      </div>
    }

    <!-- Contenu principal -->
    @if (!loading && !errorMessage) {
      <div class="dialog-content">
        <!-- <div class="groups-info">
        <p *ngIf="managedGroups.length > 0" class="managed-groups-info">
          <mat-icon>shield</mat-icon>
          Vous gérez {{ managedGroups.length }} groupe(s)
        </p>
        <p *ngIf="adminGroups.length > 0" class="admin-groups-info">
          <mat-icon>people</mat-icon>
          Vous avez accès à {{ adminGroups.length }} groupe(s)
        </p>
      </div> -->
      <div class="groups-columns">
        <!-- Colonne des groupes assignés -->
        <div class="groups-column assigned-column">
          <div class="column-header">
            <mat-icon class="header-icon">check_circle</mat-icon>
            <h3>Groupes Assignés</h3>
            <span class="count-badge">{{ filteredAssignedGroups.length }}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="groups-list">
            @for (group of filteredAssignedGroups; track group) {
              <div
                class="group-item assigned-item"
                [class.processing]="isProcessing(group.name)"
                >
                <div class="group-info">
                  <div class="group-name">{{ group.name }}</div>
                  <div class="group-path">{{ group.displayPath || getGroupDisplayPath(group) }}</div>
                </div>
                <button
                  mat-icon-button
                  class="action-btn remove-btn"
                  (click)="confirmRemoveFromGroup(group)"
                  [disabled]="isProcessing(group.name) || loading"
                  matTooltip="Retirer du groupe"
                  >
                  @if (!isProcessing(group.name)) {
                    <mat-icon>remove_circle</mat-icon>
                  }
                  @if (isProcessing(group.name)) {
                    <mat-spinner diameter="20"></mat-spinner>
                  }
                </button>
              </div>
            }
            @if (filteredAssignedGroups.length === 0) {
              <div class="empty-state">
                <mat-icon>info</mat-icon>
                <p>{{ searchControl.value ? 'Aucun groupe assigné trouvé' : 'Aucun groupe assigné' }}</p>
                @if (adminGroups.length === 0) {
                  <p class="hint">Vous n'avez accès à aucun groupe</p>
                }
              </div>
            }
          </div>
        </div>
        <!-- Colonne des groupes disponibles -->
        <div class="groups-column available-column">
          <div class="column-header">
            <mat-icon class="header-icon">group_add</mat-icon>
            <h3>Groupes Disponibles</h3>
            <span class="count-badge">{{ filteredAvailableGroups.length }}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="groups-list">
            @for (group of filteredAvailableGroups; track group) {
              <div
                class="group-item available-item"
                [class.processing]="isProcessing(group.name)"
                >
                <div class="group-info">
                  <div class="group-name">{{ group.name }}</div>
                  <div class="group-path">{{ group.displayPath || getGroupDisplayPath(group) }}</div>
                </div>
                <button
                  mat-icon-button
                  class="action-btn add-btn"
                  (click)="addToGroup(group)"
                  [disabled]="isProcessing(group.name) || loading"
                  matTooltip="Ajouter au groupe"
                  >
                  @if (!isProcessing(group.name)) {
                    <mat-icon>add_circle</mat-icon>
                  }
                  @if (isProcessing(group.name)) {
                    <mat-spinner diameter="20"></mat-spinner>
                  }
                </button>
              </div>
            }
            @if (filteredAvailableGroups.length === 0) {
              <div class="empty-state">
                <mat-icon>info</mat-icon>
                <p>{{ searchControl.value ? 'Aucun groupe disponible trouvé' : 'Tous les groupes sont assignés' }}</p>
                @if (adminGroups.length === 0) {
                  <p class="hint">Vous n'avez accès à aucun groupe</p>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Actions du dialog -->
  <div class="dialog-actions">
    <button mat-stroked-button (click)="close()" [disabled]="loading">
      Fermer
    </button>
    <button mat-button color="#45B56F" (click)="refreshData()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
      Rafraîchir
      @if (refreshing) {
        <mat-spinner diameter="20" class="refresh-spinner"></mat-spinner>
      }
    </button>
  </div>
</div>